import type { ConceptDef } from '../types';

export const emotionToScenario: ConceptDef = {
  kind: 'tileMatch',
  id: 'emotion-to-scenario',
  label: 'Emotion-to-Scenario',
  category: 'Social',
  description: 'Hear a short scenario; tap the matching emotion.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'You got a present.', answer: '😀 happy' },
      { say: 'Your favorite toy broke.', answer: '😢 sad' },
      { say: 'Someone took your turn.', answer: '😡 angry' },
      { say: 'A loud noise startled you.', answer: '😨 scared' },
      { say: 'You finished a hard puzzle.', answer: '🥳 proud' },
    ],
  },
};
